class SharePlatformUrl {
    constructor(options) {
        this.twiter = document.querySelectorAll(options.twiter)
        this.email = document.querySelectorAll(options.email)
        this.facebook = document.querySelectorAll(options.facebook)
        this.copy = document.querySelectorAll(options.copy)

        this.init()
    }
    init() {
        this.twiter.forEach(i => {
            i.addEventListener('click', () => {
                this.shareOnTwitter()
            })
        })

        this.email.forEach(i => {
            i.addEventListener('click', () => {
                const bb = i.getAttribute('data-productName')
                this.shareOnEmail('', bb)
            })
        })

        this.facebook.forEach(i => {
            i.addEventListener('click', () => {
                this.shareOnFacebook()
            })
        })

        let clipboard = new ClipboardJS('.copy', {
            text: () => `${location.href}`
        });

        clipboard.on('success', function (e) {
            e.clearSelection();
        })
        clipboard.on('error', function (e) {
            console.info('error:', e);
        })

    }

    shareOnTwitter() {
        let text = document.title;
        let url = location.href;
        let via = "";
        let hashtags = "beetlesgel;";
        let intentUrl = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url) + "&via=" + encodeURIComponent(via) + "&hashtags=" + encodeURIComponent(hashtags);
        window.open(intentUrl, "_blank", "width=550,height=420");
    }

    shareOnFacebook () {
        window.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(window.location.href)+"&t="+document.title, '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
        return false;
    }

    concatStr (str, key, value) {
        if (str !== '') {
            return `${str}&${key}=${value}`
        }
        return `${key}=${value}`
    }

    shareOnEmail (to = '', body) {
        let str = '';
        str = this.concatStr(str, 'subject', document.title);
        str = this.concatStr(str, 'body', body);
        const content = `mailto:${to}?${str}`;
        const aTag = window.document.createElement('a');
        aTag.setAttribute('href', content);
        aTag.click();
    }
}
